import isUndefined from 'lodash.isundefined';
import { useState, useEffect } from 'react';
import useCartFromAPI from '@hooks/apiLegacy/useCartFromAPI';
import useViewer from '@hooks/useViewer';

const useIsCartMultiCurrency = ({ locale }) => {
    const [isCartMultiCurrency, setIsCartMultiCurrency] = useState();
    const { viewer } = useViewer();
    const { cart } = useCartFromAPI({ viewerId: viewer?.recordId });

    useEffect(() => {
        if (isUndefined(viewer)) {
            return;
        }

        if (viewer === null) {
            setIsCartMultiCurrency(false);
            return;
        }

        if (!cart || !locale) {
            return;
        }

        if (cart.items.length === 0) {
            setIsCartMultiCurrency(false);
            return;
        }

        setIsCartMultiCurrency(cart.locale !== locale);
    }, [viewer, cart, locale]);

    return { isCartMultiCurrency };
};

export default useIsCartMultiCurrency;
